/**
 * Email format validation using the HTML5 spec regex.
 * Matches browser `<input type="email">` behavior exactly.
 * @see https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
 */
const HTML5_EMAIL_RE = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export function isValidEmail(email: string): boolean {
  return HTML5_EMAIL_RE.test(email);
}
